(function () {
    function r(e, n, t) {
        function o(i, f) {
            if (!n[i]) {
                if (!e[i]) {
                    var c = "function" == typeof require && require;if (!f && c) return c(i, !0);if (u) return u(i, !0);var a = new Error("Cannot find module '" + i + "'");throw a.code = "MODULE_NOT_FOUND", a;
                }var p = n[i] = { exports: {} };e[i][0].call(p.exports, function (r) {
                    var n = e[i][1][r];return o(n || r);
                }, p, p.exports, r, e, n, t);
            }return n[i].exports;
        }for (var u = "function" == typeof require && require, i = 0; i < t.length; i++) {
            o(t[i]);
        }return o;
    }return r;
})()({ 1: [function (require, module, exports) {
        (function () {
            function init() {
                document.querySelectorAll('[data-hotel-excursions-preview]').forEach(function (root) {
                    var pending = false;
                    var content = root.querySelector('[data-excursions-content]');
                    var error = root.querySelector('[data-excursions-error]');
                    var loading = root.querySelector('[data-excursions-loading]');
                    var skeleton = root.querySelector('.hotel-excursions-skeleton');
                    function load() {
                        if (pending) return;
                        pending = true;
                        error.hidden = true;
                        loading.hidden = false;
                        skeleton.hidden = false;
                        return fetch(root.dataset.loadUrl, { credentials: 'same-origin', headers: { 'X-Requested-With': 'XMLHttpRequest' } }).then(function (response) {
                            if (!response.ok) throw new Error('Excursions HTTP ' + response.status);
                            return response.text();
                        }).then(function (html) {
                            if (!html.trim()) {
                                root.remove();return;
                            }
                            content.innerHTML = html;
                            root.classList.remove('hotel-excursions-preview');
                        }).catch(function () {
                            pending = false;
                            loading.hidden = true;
                            skeleton.hidden = true;
                            error.hidden = false;
                        });
                    }
                    root.querySelector('[data-excursions-retry]').addEventListener('click', load);
                    if (window.IntersectionObserver) {
                        var observer = new IntersectionObserver(function (entries) {
                            if (entries.some(function (entry) {
                                return entry.isIntersecting;
                            })) {
                                observer.disconnect();
                                load();
                            }
                        }, { rootMargin: '300px 0px' });
                        observer.observe(root);
                    } else load();
                });
            }
            if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);else init();
        })();
    }, {}] }, {}, [1]);